import * as actionTypes from './actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.deeplink, action) {
  switch (action.type) {
    case actionTypes.SET_IS_DEEPLINK:
      return { ...state, isDeeplink: action.payload };
    case actionTypes.SET_IS_DEEPLINKING:
      return { ...state, isDeeplinking: action.payload };
    case actionTypes.SET_DEEPLINK_NAVIGATION:
      return { ...state, navigation: action.payload };
    case actionTypes.SET_DEEPLINK_KIND:
      return { ...state, kind: action.payload };
    case actionTypes.SET_VERIFIED_VEHICLE:
      return { ...state, verifiedVehicle: action.payload };
    case actionTypes.SET_INCOMPLETE_VEHICLE:
      return { ...state, incompleteVehicle: action.payload };
    case actionTypes.SET_APPT_REVISIT:
      return { ...state, apptRevisit: action.payload };
    case actionTypes.SET_HAS_SERVICES:
      return { ...state, hasServices: action.payload };
    case actionTypes.SET_HAS_TRANSPORTATION_OPTIONS:
      return { ...state, hasTransportationOption: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/deeplink/reducer.js